module.exports = __webpack_public_path__ + "static/media/acquajet.d2651116.webp";